import { render } from "./StandingsSunB.vue?vue&type=template&id=bb8f0694&scoped=true"
import script from "./StandingsSunB.vue?vue&type=script&scoped=true&lang=js"
export * from "./StandingsSunB.vue?vue&type=script&scoped=true&lang=js"

import "./StandingsSunB.vue?vue&type=style&index=0&id=bb8f0694&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb8f0694"]])

export default __exports__